var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('properties-payment-form',{attrs:{"loading":_vm.loading,"propertiesPaymentData":_vm.propertiesPayment,"formErrors":_vm.formErrors},on:{"propertiesPaymentSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }